<template>
  <nav
    :class="{sidebar: true, sidebarStatic, sidebarOpened}"
    @mouseenter="sidebarMouseEnter"
    @mouseleave="sidebarMouseLeave"
  >
    <header class="logo">
      <img style="width:190px;height:40px" src="../../assets/images/corpolex_full_logo.png"/>
    </header>
    <ul class="nav">

<NavLink
        header="Inicio"
        link="/app/videosPrincipal"
        iconName="flaticon-home"
        index="videosPrincipal"
        isHeader
      />
<!--
      <NavLink
        header="Documentos"
        link="/app/documentos"
        iconName="flaticon-list"
        index="documentos"
        isHeader
      />

      <NavLink
        header="CDC"
        link="/app/dashboard"
        iconName="flaticon-home"
        index="dashboard"
        isHeader
      />

      <NavLink
        header="CDC Chart"
        link="/app/components/cdccharts"
        iconName="flaticon-network"
        index="cdccharts"
        isHeader
      />
      -->
  <!--
       <NavLink
        header="Tables Basic"
        link="/app/tables"
        iconName="flaticon-equal-1"
        index="tables"
        isHeader
      />
   
-->
      <NavLink v-show="this.id_role == 1"
        :activeItem="activeItem"
        header="Administración"
        link="/abc"
        iconName="flaticon-network"
        index="abc"
        :childrenLinks="[
          { header: 'Clientes', link: '/app/abcempresas' },
          { header: 'Locales', link: '/app/abclocales' },
          { header: 'Usuarios', link: '/app/abcusuarios' },
        ]"
      />


    </ul>
    
  
   
  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import isScreen from '@/core/screenHelper';
import NavLink from './NavLink/NavLink';

export default {
  name: 'Sidebar',
  components: { NavLink },
  data() {
    return {
      id_role: null,

      alerts: [
        {
          id: 0,
          title: 'Sales Report',
          value: 15,
          footer: 'Calculating x-axis bias... 65%',
          color: 'info',
        },
        {
          id: 1,
          title: 'Personal Responsibility',
          value: 20,
          footer: 'Provide required notes',
          color: 'danger',
        },
      ],
    };
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/');
      paths.pop();
      this.changeSidebarActive(paths.join('/'));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    },
  },
  created() {

     this.id_role = window.localStorage.getItem('id_role');

    //alert(this.id_role);

    this.setActiveByRoute();
  },
  computed: {
    ...mapState('layout', {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement,
    }),
  },
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
